import { format } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';

export type BillingDateChange = { billingCycleAnchor: Date; timeOfDay?: 'exact' };

/**
 * The payload of a billing-date change: the day alone keeps each subscription's current time of
 * day (server default); a typed time ("HH:mm") is read on the wall clock of `timezone` and sent as
 * an exact instant.
 */
export const billingDateChange = (day: Date, time: string, timezone: string): BillingDateChange => {
  if (time === '') return { billingCycleAnchor: day };
  const wallClock = `${format(day, 'yyyy-MM-dd')}T${time}:00`;
  return { billingCycleAnchor: fromZonedTime(wallClock, timezone), timeOfDay: 'exact' };
};
